import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import moment from 'moment'
import {KTSVG} from '../../../../../_metronic/helpers'

function ShareFileLinkModal({
  shareFileInfo,
  showShareFileLinkModal,
  handleCloseShareFileLinkModal,
}: any) {
  const intl = useIntl()

  const handleCopy = (text: any) => {
    navigator.clipboard.writeText(text)
  }

  const extractVehicleNo = (title: string) => {
    const match = title.match(/vehicle:\s*(.*)$/i)
    return match ? match[1].trim() : '-'
  }

  const formatDateTime = (StartEpoch: any, EndEpoch: any) => {
    const startMoment = moment.unix(StartEpoch)
    const endMoment = moment.unix(EndEpoch)
    const datePart = startMoment.format('YYYY-MM-DD')
    const startTime = startMoment.format('HH:mm:ss')
    const endTime = endMoment.format('HH:mm:ss')

    const formatted = `${datePart} | ${startTime} - ${endTime}`
    return formatted
  }

  return (
    <>
      {showShareFileLinkModal && shareFileInfo ? (
        <Modal show={showShareFileLinkModal} onHide={handleCloseShareFileLinkModal} centered>
          <Modal.Body>
            <div className='mdt-links-container'>
              <div className='d-flex w-100 align-items-center justify-content-between'>
                <h1 className='text-primary d-flex gap-3 align-items-center'>
                  {intl.formatMessage({id: 'GENERAL.LABEL.SHARE_LINK_TO_FILE'})}
                </h1>
                <button
                  className='btn btn-link p-0'
                  type='button'
                  onClick={handleCloseShareFileLinkModal}
                >
                  <i
                    className='fa fa-times-thin fa-2x'
                    aria-hidden='true'
                    style={{fontSize: '2em', padding: 0, verticalAlign: 'unset'}}
                  ></i>
                </button>
              </div>
              <div className='d-flex gap-5 align-items-center'>
                <label className='form-label fs-6 text-dark m-0'>
                  {shareFileInfo.fileData.title
                    ? extractVehicleNo(shareFileInfo.fileData.title)
                    : '-'}
                </label>
                <label className='form-label fs-6 m-0 text-gray-600'>
                  {shareFileInfo.fileData.deviceId ? shareFileInfo.fileData.deviceId : '-'}
                </label>
              </div>
              <div>
                <span className='fw-bolder'>
                  {intl.formatMessage({id: 'DEVICE.RECORDED_VIDEO'})}
                </span>
                :{' '}
                <span className='fw-bold'>
                  {shareFileInfo.fileData.startEpoch && shareFileInfo.fileData.endEpoch
                    ? formatDateTime(
                        shareFileInfo.fileData.startEpoch,
                        shareFileInfo.fileData.endEpoch
                      )
                    : '-'}
                </span>
              </div>
              <div className='line-break w-100 ' style={{backgroundColor: '#EFF2F5', height: 1}} />

              <div className='d-flex align-items-center justify-content-between gap-2'>
                <div>
                  <span className='fw-bolder'>
                    {intl.formatMessage({id: 'GENERAL.LABEL.VIDEO_LINK'})}
                  </span>
                  : {shareFileInfo?.ShareLink}
                </div>
                <button
                  type='button'
                  className='btn btn-sm border border-primary text-primary copy-btn rounded-3 cursor-pointer'
                  onClick={() => handleCopy(shareFileInfo?.ShareLink)}
                >
                  <KTSVG path='/media/icons/duotone/General/Copy.svg' />
                  {intl.formatMessage({id: 'GENERAL.LABEL.COPY_BUTTON'})}
                </button>
              </div>
              <div className='d-flex align-items-center justify-content-between gap-2'>
                <div>
                  <span className='fw-bolder'>
                    {intl.formatMessage({id: 'AUTH.INPUT.PASSWORD'})}
                  </span>
                  : {shareFileInfo?.Password}
                </div>
                <button
                  type='button'
                  className='btn btn-sm border border-primary text-primary copy-btn rounded-3 cursor-pointer'
                  onClick={() => handleCopy(shareFileInfo?.Password)}
                >
                  <KTSVG path='/media/icons/duotone/General/Copy.svg' />
                  {intl.formatMessage({id: 'GENERAL.LABEL.COPY_BUTTON'})}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      ) : (
        <></>
      )}
    </>
  )
}

export default ShareFileLinkModal
